import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { StateService } from 'projects/shared/src/public-api';

@Component({
    selector: 'lib-calendar-management',
    templateUrl: './calendar-management.component.html',
    styleUrls: ['./calendar-management.component.scss'],
    standalone: false
})
export class CalendarManagementComponent implements OnInit {
  constructor(private modalCtrl: ModalController, public state: StateService) {}

  cancel() {
    return this.modalCtrl.dismiss(null, 'cancel');
  }

  confirm() {
    this.state.refreshCalendarState();
    return this.modalCtrl.dismiss(',', 'confirm');
  }

  ngOnInit() {}

  onCheckboxChange(event: any) {
    // this.isChecked = event.detail.checked;
    // this.checkboxColor = this.isChecked ? 'success' : 'danger'; // Beispiel
  }
}
